import React from "react";
import { Redirect } from "react-router-dom";
import LiveVehiclesLists from "../pages/LIVEdata/LiveVehiclesLists";
import LiveLoadLists from "../pages/LIVEdata/LiveLoadLists";
import BusinessCardList from "../pages/BusinessCard/BusinessCardList";
// User profile
import UserProfile from "../pages/Authentication/UserProfile";
// User Chagne password
import ChangePassword from "../pages/Authentication/ChangePassword";
// User UpdateDetails
import UpdateDetails from "../pages/User/UpdateDetails";
import MtUsersList from "../pages/User/mtUsersList";
import MtgpsUserList from "../pages/User/mtgpsUserList";
import AddUser from "../pages/User/addUser";
// User Vehicle
import GpsUser from "../pages/Vehicle/GpsUser";
import UserVehicleList from "../pages/Vehicle/UserVehicleList";
import PostLoad from "../pages/Vehicle/PostLoad";
import MemberLoadPost from "../pages/Vehicle/MemberLoadList";
import EditLoadPost from "../pages/Vehicle/EditLoadPost";
import PostLoadlist from "../pages/Vehicle/PostLoadList";
import VehicleRegister from "../pages/Vehicle/VehicleRegister";
import SearchVehicleDetails from "../pages/Vehicle/SearchVehicleDetails";
import VehicleList from "../pages/Vehicle/VehicleList";
import VehicleType from "../pages/Vehicle/VehicleTypelist";
import EditVehicleDetails from "../pages/Vehicle/EditVehicleDetails";
import RateCard from "../pages/Vehicle/RateCard";
import NeedLoadList from "../pages/Vehicle/NeedLoadList";
import GpsDeviceDataList from "../pages/Vehicle/GpsDeviceDataList"
//Listing
import AddBusinessProfile from "../pages/Listing/AddBusinessProfile";
import TransporterList from "../pages/Listing/TransporterSearch";
import PackersAndMovers from "../pages/Listing/PackersAndMoversList";
import UpdateBusinessList from "../pages/Listing/updateBusinessList";
// User Notification
import Notification from "../pages/Dashboard/notificationList";
// Transaction
import Transaction from "../pages/Transactions/Transaction";
// Live location Map
import NearVehicle from "../pages/Map/NearVehicle";
import LiveVehicle from "../pages/Map/LiveVehicle";
import vehicleLocation from "../pages/Map/VehicleLocation";
// pricing
import Pricing from "../pages/Subscription/Pricing";
import Kyc from "../pages/Subscription/Kyc";
// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import OtpVerification from "../pages/Authentication/OtpVerification";
//Help
import Faq from "../pages/Other/Faq";
import Help from "../pages/Other/Help";
import ContactUs from "../pages/Other/ContactUs";
import SystemData from "../pages/Other/SystemData";
//Report
import SubscriberUser from "../pages/Report/subscriber-user";
import UnsubcriberUser from "../pages/Report/unsubscriber-user";
import TodayUser from "../pages/Report/today-user";
  // Dashboard
import Dashboard from "../pages/Dashboard/index";
//ManageUsers
import AdminUsersList from "../pages/ManageUser/AdminUsersList";
import CreateAdminUser from "../pages/ManageUser/CreateAdminUser";
const authProtectedRoutes = [
	{ path: "/dashboard", component:Dashboard},
	//profile
	{ path: "/profile", component:UserProfile},
	{ path: "/UpdateDetails", component:UpdateDetails},
	//Users
	{path:"/mtUsersList",component:MtUsersList, requiredPermission: "mtUsersList"
},
	{path:"/mtgpsUserList",component:MtgpsUserList, requiredPermission: "mtgpsUserList"
},
	{path:"/AddUser",component:AddUser, requiredPermission: "AddUser"
},
	//changpassword
	{ path: "/changepassword", component: ChangePassword },
	//Vehicle 
	{ path: "/postload", component: PostLoad, requiredPermission: "postload"
 },
	{ path: "/memberLoadPost", component: MemberLoadPost, requiredPermission: "memberLoadPost"
 },
	{ path: "/editLoadPost", component: EditLoadPost, requiredPermission: "editLoadPost"
 },
	{ path: "/postloadlList", component: PostLoadlist, requiredPermission: "postloadlList"
 },
	{ path: "/vehicleRegister", component: VehicleRegister, requiredPermission: "vehicleRegister"
 },
	{ path: "/editVehicleDetails", component: EditVehicleDetails , requiredPermission: "editVehicleDetails"
},
	{ path: "/searchVehicleDetails", component:  SearchVehicleDetails, requiredPermission: "searchVehicleDetails"
 },
	{ path: "/vehicleList", component:  VehicleList, requiredPermission: "vehicleList"
 },
	{ path: "/vehicleTypeList", component: VehicleType,requiredPermission: "vehicleTypeList"
 },
	{ path: "/RateCard", component: RateCard, requiredPermission: "RateCard"
},
	{ path: "/NeedLoadList", component: NeedLoadList,requiredPermission: "NeedLoadList"
},
	{path:"/GpsUser",component:GpsUser, requiredPermission: "GpsUser"
},
	{path:"/UserVehicleList",component:UserVehicleList, requiredPermission: "UserVehicleList"
},
	{path:"/GpsDeviceDataList",component:GpsDeviceDataList, requiredPermission: "GpsDeviceDataList"
},
	//Listing 
	{ path: "/AddBusinessProfile", component: AddBusinessProfile, requiredPermission: "AddBusinessProfile"
 },
	{ path: "/transporterList", component: TransporterList, requiredPermission: "transporterList"
 },
	{ path: "/packersAndMovers", component: PackersAndMovers, requiredPermission: "packersAndMovers"
 },
	{ path: "/UpdateBusinessList", component: UpdateBusinessList, requiredPermission: "UpdateBusinessList"
 },

{
	path: "/LiveVehiclesLists", component: LiveVehiclesLists, requiredPermission: "LIVE_VEHICLE_LISTS"
},

{
	path: "/LiveLoadLists", component: LiveLoadLists, requiredPermission: "LIVE_LOAD_LISTS"
},

{path: "/BusinessCardList", component: BusinessCardList, requiredPermission: "BusinessCardList"},

	//OtherPages 
	{ path: "/faq", component: Faq},
	{ path: "/help", component: Help},
	{ path: "/ContactUs", component: ContactUs, requiredPermission: "ContactUs"
},
	{path:"/SystemData",component:SystemData, requiredPermission: "SystemData"
},
	//Live Location Map 
	{ path: "/nearVehicle", component: NearVehicle ,requiredPermission: "nearVehicle"
},
	{ path: "/liveVehicle", component: LiveVehicle, requiredPermission: "liveVehicle"
},
	{ path: "/vehicleLocation", component: vehicleLocation, requiredPermission: "vehicleLocation"
},
	//Live Subscription Map 
	{ path: "/pricing", component: Pricing, requiredPermission: "pricing"},
	{ path: "/Kyc", component: Kyc, requiredPermission: "Kyc"},
	//Notification
	{ path: "/Notification", component: Notification },
	//manageusers
	{
  path: "/AdminUsersList",
  exact: true,
  component: AdminUsersList,
  requiredPermission: "AdminUsersList"
},
{
  path: "/CreateAdminUser/:id?",
  exact: true,
  component: CreateAdminUser,
  requiredPermission: "CreateAdminUser"
},
	//Transactions
	{ path: "/transaction", component: Transaction },
	{path:"/subscriberUser", component:SubscriberUser},
	{path:"/unsubcriberUser", component:UnsubcriberUser},
	{path:"/todayUser", component:TodayUser},
	// this route should be at the end of all other routes
	{ path: "/", exact: true, component: () => <Redirect to="/dashboard" /> }
];
const publicRoutes = [
	{ path: "/logout", component: Logout },
	{ path: "/login", component: Login },
	{ path: "/forgot-password", component: ForgetPwd },
	{ path: "/register", component: Register },
	{ path: "/otpVerification", component: OtpVerification },

];
export { authProtectedRoutes, publicRoutes };
